import { render } from "./fwscript.md?vue&type=template&id=cd795974"
import script from "./fwscript.md?vue&type=script&lang=js"
export * from "./fwscript.md?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__